/**
 * BrandMark — Logo da marca App Saúde
 * Suporta tamanhos dinâmicos (sm, md, lg, xl, 2xl) e classes customizadas
 */
import { cn } from '@/lib/utils';
import { BRAND_WORDMARK } from '@/lib/brand.constants';

type BrandSize = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

type BrandMarkProps = {
  variant?: 'horizontal' | 'icon';
  size?: BrandSize;
  className?: string;
  imageClassName?: string;
};

const SIZE_CLASSES: Record<BrandSize, string> = {
  sm: 'h-8 w-8',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
  xl: 'h-24 w-24',
  '2xl': 'h-32 w-32',
};

export function BrandMark({
  variant = 'horizontal',
  size = 'md',
  className,
  imageClassName,
}: BrandMarkProps) {
  const baseImgClass = cn(
    'object-contain shrink-0 transition-transform duration-200',
    imageClassName || SIZE_CLASSES[size],
  );

  return (
    <div className={cn('flex items-center', variant === 'icon' && 'justify-center', className)}>
      <img
        src="/images/logo.png"
        alt={BRAND_WORDMARK}
        className={cn(baseImgClass, 'dark:hidden')}
      />
      <img
        src="/images/dark-logo.png"
        alt={BRAND_WORDMARK}
        className={cn(baseImgClass, 'hidden dark:block')}
      />
    </div>
  );
}
